import React, { FC, memo } from "react";
import { components } from "react-select";
import { InputProps } from "react-select/src/components/Input";

import { SELECT_CLASS_NAME } from "../types";

const baseClass = `${SELECT_CLASS_NAME}__input`;
const wrapperClass = `${baseClass}-wrapper`;

const { Input: RSInput } = components;

export const Input: FC<InputProps> = memo(props => {
  return (
    <div className={wrapperClass}>
      <RSInput {...props} />
    </div>
  );
});
